var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.config)?_c(_vm.configType,{tag:"component",model:{value:(_vm.config.data),callback:function ($$v) {_vm.$set(_vm.config, "data", $$v)},expression:"config.data"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }